import {Pressable, StyleSheet, Text, TextStyle} from "react-native";
import {Image, ImageStyle} from "expo-image";
import {BASE_URL} from "@/lib/constants";
import {GroupAvatar, UserAvatar} from "@/lib/types";
import {useRouter} from "expo-router";

type Props = {
    avatar: UserAvatar | GroupAvatar,
    pressable?: boolean,
    size?: number,
}

export default function Avatar({avatar, pressable, size}: Props) {
    const router = useRouter();
    const userAvatar = avatar as UserAvatar;
    const iconSize = !!size ? size : 32;

    if (avatar.avatar_url) {
        const style: ImageStyle = {
            borderColor: avatar.color,
            width: iconSize,
            height: iconSize,
            borderRadius: iconSize,
        };
        return (
            <Pressable onPress={() => router.navigate(`/u/profile/${userAvatar.username}`)} disabled={!pressable}>
                <Image
                    style={[styles.avatar, style]}
                    source={BASE_URL + avatar.avatar_url}
                />
            </Pressable>
        )
    } else {
        const style: TextStyle = {
            borderColor: avatar.color,
            backgroundColor: avatar.color,
            color: avatar.contrast_color,
            width: iconSize,
            height: iconSize,
            lineHeight: iconSize,
            borderRadius: iconSize,
        };
        return (
            <Pressable onPress={() => router.navigate(`/u/profile/${userAvatar.username}`)} disabled={!pressable}>
                <Text
                    style={[styles.avatar, style]}
                    selectable={false}
                >
                    {userAvatar.username.substring(0, 2)}
                </Text>
            </Pressable>
        )
    }
}

export const styles = StyleSheet.create({
    avatar: {
        borderWidth: 2,
        textAlign: "center",
        textAlignVertical: "center",
        fontSize: 14,
        fontWeight: 600,
        textTransform: "uppercase",
    },
})